/** Namespaces of the application */
export enum Namespace {
    App = 'PATHFINDER/APP',
}

/**
 * Queries of the application
 */
export enum AppQuery {
    Pathfinder = 'pathfinder',
}
